import React from 'react';

export default function ({ feedItem, eleRef }) {
    return (


        <section className="main_container_block_feeds">
        <div className="main_block_container_feed">
           <div className="block_container_feed_heading_text R15_61">
               <span className="" role='heading' tabIndex={0} aria-label={feedItem.title?feedItem.title:'Upload Your Photo'}> {feedItem.title?feedItem.title:'Upload Your Photo'} </span>
            </div>
            <div className="content-div-box-artical desktop_view_upload_faceDay">
               <div className="common-day-upload-image mr_b12">
                   <div className="face_day_cover_photo">
                        <img src={feedItem.backgroundImage?feedItem.backgroundImage:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Face a day BG.webp"} alt="face a day background" title='face a day background'/>
                   </div>
                               
                    <div className="face_day_container-circle">
                        <div className="face_day_cover_photo2">
                            <img src={feedItem.data[0].frameImage?feedItem.data[0].frameImage:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Face a day frame.png"} alt="face a day frame" title='face a day frame'/>
                        <div className="add_photo_top_day" aria-label='add photo to my bumpie'>
                            <label className="add_photo_lbl" htmlFor="face_upload" >
                               <div className="face_day_camera">
                                 <img src={feedItem.data[0].cameraUrl?feedItem.data[0].cameraUrl:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Camera Icon.png"} alt="camera icon" title='camera icon'/> 
                               </div>
                               <a href={"https://parenting.firstcry.com/tools/uploadmybumpie?"+feedItem.data[0].frameId} role='button' tabIndex={0} aria-label='add photo'>
                                <span className="M12_42 add_photo_uf gtm-mybumpie-upload">
                                        Add Photo
                                </span>
                                </a>
                            </label>
                        </div>
                        <input type="file" name="face_upload" id="face_upload" className="face_upload" accept="image/*" onChange={(e) => this.onChange(e)} style={{ 'display': 'none' }} />
                    </div>
                </div>
            </div>
            <div className="face_profile_bottom">
               <div className="memory_user_details">
                    <div className="profile_left_day">
                        <div className="user-dp">
                          <img src={feedItem.data[0].childObj.userImageUrl?feedItem.data[0].childObj.userImageUrl:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"} alt={feedItem.data[0].childObj.userName} title={feedItem.data[0].childObj.userName} /> 
                        </div>
                        <div className="user-info">
                            <span className="user-name M16_21">{feedItem.data[0].childObj.userName}</span>
                            <span className="user-desc R14_61"> {feedItem.data[0].childObj.userDesc?feedItem.data[0].childObj.userDesc:''}</span>
                        </div>
                    </div>
                    <div className="user_right_info right">
                        <a href="https://parenting.firstcry.com/tools/my-baby-bump/">
                     <span className="user-post-time gtm-mybumpie-upload" tabIndex={0} aria-label='upload now'>Upload Now</span>
                     </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

    )
}
